import { render, staticRenderFns } from "./messege_reject.vue?vue&type=template&id=433b7b12&scoped=true"
import script from "./messege_reject.vue?vue&type=script&lang=js"
export * from "./messege_reject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433b7b12",
  null
  
)

export default component.exports